import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Every route change starts at the top of the page.
 *
 * Without this, React Router preserves the previous scroll offset, so moving
 * from halfway down a category listing into a product page drops you into the
 * middle of the new page. In-page anchors (e.g. #reviews) are left alone.
 */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links (#reviews) scroll themselves
    // Disable the browser's own restoration so ours always wins on back/forward.
    if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, search, hash]);

  return null;
}
